import { render, staticRenderFns } from "./Floating.vue?vue&type=template&id=461b1c5c&"
import script from "./Floating.vue?vue&type=script&lang=js&"
export * from "./Floating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports